module.exports = __webpack_public_path__ + "static/media/YM06_0.d6e4c1c1.jpg";